export const Crc32AuthCommand = {
  rental: 0x0e,
  returnExec: 0x0f,
  forceUnlock: 0x0a,
  rentalResponse: 0x8e,
  returnResponse: 0x8f,
} as const

export const FRAME_HEADER = 0x02
export const FRAME_FOOTER = 0xff
export const TIMESTAMP_BYTE_LENGTH = 5
export const AUTH_CODE_BYTE_LENGTH = 4
export const FRAME_OVERHEAD_BYTE_LENGTH = 5
export const TIMESTAMP_MASK = 0xffffffffff

export type Crc32AuthResultFrame = {
  rawData: number[]
  commandCode: number
  resultCode: number
  switchStatus: number
  area1CardNumber: number[] | null
  area2CardNumber: number[] | null
  remainingUmbrellaCount: number
  batteryLevel: number
  firmwareVersion: number
  failureFlag: number
}

export type Crc32AuthParseEvent =
  | { type: 'ack' }
  | { type: 'result'; frame: Crc32AuthResultFrame }
